<template>
    <a-modal width="65%" title="查看" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @cancel="onClose" :footer="null" wrap-class-name="single-spa-vue">

        <a-descriptions :column="1" bordered>

            <a-descriptions-item label="商标名称">{{ form.brandName }}</a-descriptions-item>
            <a-descriptions-item label="适用范围">
                <span v-html="form.scopeApplication"></span>
            </a-descriptions-item>
            <a-descriptions-item label="保护范围分析">
                <span v-html="form.rangeAnalysis"></span>
            </a-descriptions-item>
            <a-descriptions-item label="商标行业类型">
                <dict-render :dict-obj="dictObjs['projectType']" :text="form.brandIndustryType"
                             v-if="form.brandIndustryType"></dict-render>
            </a-descriptions-item>

            <a-descriptions-item label="注册公告期号">{{form.brandNumber}}</a-descriptions-item>

            <a-descriptions-item label="审核时间">{{form.firstTime}}</a-descriptions-item>

            <a-descriptions-item label="审核状态">
                <dict-render :dict-obj="dictObjs['aduit_status']" :text="form.auditStatus"
                             v-if="form.auditStatus"></dict-render>
            </a-descriptions-item>


        </a-descriptions>
    </a-modal>
</template>

<script>
    import {formMixin, dictMixin} from "@/mixins";
    import DictRender from "@/components/other/DictRender";

    export default {
        name: "Detail",
        mixins: [formMixin, dictMixin],
        components: {DictRender},
        data() {
            return {
                dictNames: "demand_type,aduit_status,projectType",
                form: {
                    id: null,
                    brandName: null,
                    scopeApplication: null,
                    brandIndustryType: null,
                    rangeAnalysis: null,
                    firstTime:null,
                    auditTime: null,
                    abutmentPhone: null,
                    abutmentUserName: null,
                    abutmentStartTime: null,
                    abutmentEndTime: null,
                    serviceStatus: null,
                    isOpen: null,
                },
            }
        },
        methods: {
            onClose() {
                this.visible = false
                this.$emit("onCloseModel")
            },
        }
    }
</script>

<style scoped lang="less">

</style>
